import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthContextProvider } from 'auth-context';
import NiceModal from '@ebay/nice-modal-react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const loader = document.getElementById('loader');
const finishLoader = () => loader.classList.add('loader--finish');

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthContextProvider>
          <NiceModal.Provider>
            <App onLoad={finishLoader} />
            <ReactQueryDevtools initialIsOpen={false} />
          </NiceModal.Provider>
        </AuthContextProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
